import { DialogActions, DialogContent, Grid } from '@mui/material'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import { Info } from '@mui/icons-material'
import { Form, Formik, FormikHelpers, FormikProps, FormikValues } from 'formik'
import * as React from 'react'
import Button from '../Button'
import ResponsiveAppBar from '../ResponsiveAppBar'

export interface IESDialog<T> extends Omit<DialogProps, 'children' | 'open'> {
  bottomActions?: (props: FormikProps<T>, boundFunction?: any) => React.ReactNode
  close: () => void
  closeButtonText?: string
  children: (props: FormikProps<T>) => React.ReactNode
  initialValues?: T
  isLoading?: boolean
  open: boolean
  title: string
  titleIcon?: React.ReactElement
  save?: (values: T, formikHelpers: FormikHelpers<T>) => void
  saveButtonText?: string
  disableSaveButton?: boolean
  showSaveButton?: boolean
  validationSchema?: any
  isInitialValid?: boolean
}

export default class ESDialog<T extends FormikValues> extends React.Component<
  IESDialog<T>
> {
  public componentDidMount() {
    ;(window as any).dialogFormikRef = React.createRef()
  }

  public render() {
    const {
      bottomActions = () => null,
      close,
      closeButtonText,
      initialValues,
      isLoading,
      open,
      save,
      saveButtonText,
      disableSaveButton,
      showSaveButton = true,
      title,
      titleIcon = <Info />,
      validationSchema,
      isInitialValid,
      ...rest
    } = this.props
    return (
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        onClose={(_event, reason) => {
          // Prevent closing on backdrop click
          if (reason === 'backdropClick') {
            return
          }
          close()
        }}
        open={open}
        {...rest}
      >
        <Formik<T>
          initialValues={initialValues!}
          onSubmit={save!}
          validationSchema={validationSchema}
          isInitialValid={isInitialValid}
          innerRef={(window as any).dialogFormikRef}
        >
          {(formikProps: FormikProps<T>) => (
            <Form>
              <ResponsiveAppBar title={title} pageIcon={titleIcon} isModal={true} />
              <DialogContent style={{ marginTop: 8 }}>
                {this.props.children(formikProps)}
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ margin: '0px 20px 4px' }}
                >
                  <Grid item>{bottomActions(formikProps)}</Grid>
                  <Grid item>
                    <Button
                      onClick={close}
                      data-cy="close"
                      style={{ marginRight: '8px' }}
                    >
                      {closeButtonText ? closeButtonText : 'Close'}
                    </Button>
                    {showSaveButton && (
                      <Button
                        disabled={
                          disableSaveButton
                            ? disableSaveButton || !formikProps.isValid
                            : !formikProps.isValid
                        }
                        isLoading={
                          isLoading ||
                          formikProps.isValidating ||
                          formikProps.isSubmitting
                        }
                        color="primary"
                        onClick={formikProps.submitForm}
                        variant="contained"
                      >
                        {saveButtonText ? saveButtonText : 'Save'}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    )
  }
}
